import React from 'react';
import ScriptLoader from 'react-script-loader-hoc';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import PageTitle from '../../components/PageTitle';
import createService from './embedService';
import withGlobals from '../../components/Globals';
import { signOut } from '../Authorization/actions';

const counselorCommunityUrl = global.CounselorCommunity?.default?.default ? null : process.env.COUNSELOR_COMMUNITY_URL;
/* istanbul ignore else */
if (counselorCommunityUrl) {
  const { origin } = new URL(counselorCommunityUrl);
  global.__webpack_counscomm_public_path__ = origin;
}

export class CounselorCommunityServerlessApp extends React.PureComponent {
  static propTypes = {
    signOut: PropTypes.func,
    current: PropTypes.shape({
      viewer: PropTypes.object,
    }),
    history: PropTypes.shape({
      location: {
        state: PropTypes.object,
      },
    }),
  }

  signOut = () => {
    this.props.signOut(this.props.current.viewer);
  }

  render() {
    const CounselorCommunity = global.CounselorCommunity?.default?.default;
    return (
      <div className="counselor-community-serverless-container">
        <PageTitle title="Counselor Community" category="Awareness" />
        {CounselorCommunity ? (
          <CounselorCommunity
            embedService={createService(this.props)}
            baseUrl={process.env.COUNSELOR_COMMUNITY_API}
            signOut={this.signOut}
            lastUrlBeforeVisited={this.props?.history?.location?.state?.lastUrlBeforeVisited}
            history={this.props.history}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  current: state.current,
});

const CounselorCommunityServerlessAppLoaded = ScriptLoader(counselorCommunityUrl)(CounselorCommunityServerlessApp);
export default withRouter(withGlobals(connect(mapStateToProps, { signOut })(CounselorCommunityServerlessAppLoaded)));
